<div class="list">
  <label>{{ deselectedLabel }}:</label>
  <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="deselectedFilter" />
  <ul>
    @for (region of notSelectedRegions; track region) {
    <li
      (click)="toggleInLeftSelection(region.id)"
      [class.selected]="leftSelection.has(region.id)"
    >
      <country-flag [code]="region.country_iso"></country-flag>
      {{ region.name }}
    </li>
    }
  </ul>
</div>

@if (!readonly) {
<div class="buttons">
  <btn (click)="selectAll()" [disabled]="disabled" title="Make all available">
    <span>&gt;&gt;</span>
  </btn>
  <btn (click)="select()" [disabled]="disabled" title="Make selected available">
    <span>&gt;</span>
  </btn>
  <btn
    (click)="deselect()"
    [disabled]="disabled"
    title="Make selected not-available"
  >
    <span>&lt;</span>
  </btn>
  <btn
    (click)="deselectAll()"
    [disabled]="disabled"
    title="Make all not-available"
  >
    <span>&lt;&lt;</span>
  </btn>
</div>
} @if (readonly) {
<div class="blank"></div>
}

<div class="list">
  <label>{{ selectedLabel }}:</label>
  <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="selectedFilter" />
  <ul>
    @for (region of selectedRegions; track region) {
    <li
      (click)="toggleInRightSelection(region.id)"
      [class.selected]="rightSelection.has(region.id)"
    >
      <country-flag [code]="region.country_iso"></country-flag>
      {{ region.name }}
    </li>
    }
  </ul>
</div>
